//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  mixins: [parseTextMixin],

  props: {
    products: {
      type: Array,
      required: true
    },

    showTag: {
      type: Boolean,
      default: false
    },

    tagCopy: {
      type: String,
      default: ''
    },

    imageNumber: {
      type: Number,
      default: 2
    }
  },

  data () {
    return {
      activeVariantIndex: 0
    }
  },

  computed: {
    activeVariant () {
      return this.products[this.activeVariantIndex]
    },
    promo () {
      return this.activeVariant.promo || {}
    },
    discount () {
      if (!this.promo.value) return 0
      return this.promo.value
    },
    discountedPrice () {
      return this.activeVariant.price * (1 - this.discount)
    },
    discountedMinPrice () {
      return this.activeVariant.minPrice * (1 - this.discount)
    }
  },

  methods: {
    setActiveVariantByIndex (goToIndex) {
      this.activeVariantIndex = goToIndex
    }
  }
}
